import { PatchType } from '../../../types';

/**
 * Shared constants for operation types organized by patch type.
 * This avoids duplication across components and provides a single source of truth.
 */
export const OPERATION_TYPES_BY_PATCH_TYPE: Record<PatchType, string[]> = {
  [PatchType.PRODUCT_PRICE]: [
    'SetVariantPriceMenuPatchOperation',
    'SetModifierWeightPriceMenuPatchOperation',
    'SetModifierPriceRangesMenuPatchOperation',
  ],
  [PatchType.BUNDLE_PRICE]: [
    'SetBundlePriceMenuPatchOperation',
  ],
  [PatchType.PRODUCT_EXCLUSION]: [
    'RemoveProductMenuPatchOperation',
    'RemoveVariantMenuPatchOperation',
    'RemoveModifierFromSlotPatchOperation',
    'RemoveModifierMenuPatchOperation',
    'SetModifierWeightIsExcludedFromVariantMenuPatchOperation',
  ],
  [PatchType.BUNDLE_EXCLUSION]: [
    'RemoveBundleMenuPatchOperation',
  ]
};

/**
 * Helper function to get available operation types for a given patch type
 */
export const getOperationTypesForPatchType = (patchType: PatchType): string[] => {
  return OPERATION_TYPES_BY_PATCH_TYPE[patchType] || [];
};

/**
 * Helper function to format operation type names for display
 */
export const formatOperationTypeName = (operationType: string): string => {
  return operationType.replace('MenuPatchOperation', '').replace(/([A-Z])/g, ' $1').trim();
};